export default __webpack_public_path__ + "static/media/Soulace_Master_Plan.5998bd98.pdf";